import { decryptData } from './encrypt';

let cachedPermissions = null;
let cachedAirlineNames = null;

function secretKey() {
  return process.env.KEY || 'myscecretkey';
}

/**
 * Decrypted permissions array (cached for session).
 */
export function getPermissions() {
  if (cachedPermissions) return cachedPermissions;
  let raw = localStorage.getItem('Permissions');
  if (!raw) raw = 'null';
  cachedPermissions = decryptData(raw, secretKey()) || [];
  return cachedPermissions;
}

/**
 * Airline names the user may edit, or ['admin'] when unrestricted.
 */
export function getAirlineNames() {
  if (cachedAirlineNames) return cachedAirlineNames;
  let raw = localStorage.getItem('Airline');
  if (!raw) raw = 'null';
  const decoded = decryptData(raw, secretKey());
  const names = [];
  if (!decoded || decoded.length === 0) {
    names.push('admin');
  } else {
    for (let i = 0; i < decoded.length; i++) {
      names.push(decoded[i].name);
    }
  }
  cachedAirlineNames = names;
  return cachedAirlineNames;
}

export function clearUserContextCache() {
  cachedPermissions = null;
  cachedAirlineNames = null;
}
